module.exports = __webpack_public_path__ + "img/747.cab5df0c.jpg";